import Bowser from 'bowser';
import { COOKIES, REGIONS_CONFIG, STORAGE } from '../../scripts/constants.js';
import { getMetadata } from '../../scripts/utils/aem-utils.js';
import { cookieEnabled } from '../../scripts/utils/consent-utils.js';
import { getCookie } from '../../scripts/utils/cookie-utils.js';
import parseJSONSafe from '../../scripts/utils/parse-json-safe.js';

function getCountrySite() {
  const segment = window.location.pathname.split('/')[1];
  return REGIONS_CONFIG.includes(segment) || segment === 'corporate'
    ? `/${segment}`
    : '/global';
}

function getAdobeId() {
  return window.SAP?.visitorId?.getMarketingCloudVisitorID?.();
}

let inMemoryAdobeId;

function getAltAdobeId() {
  const KEY = 'alt_adobe_id';
  try {
    const storedAdobeId = localStorage.getItem(KEY);
    if (storedAdobeId) {
      return storedAdobeId;
    }
    inMemoryAdobeId ??= `${Date.now()}${Math.random()}`;
    localStorage.setItem(KEY, inMemoryAdobeId);
  } catch {}
  inMemoryAdobeId ??= `${Date.now()}${Math.random()}`;
  return inMemoryAdobeId;
}

function getCampaigncode() {
  const fromParam = new URLSearchParams(window.location.search).get(
    'campaigncode',
  );
  return fromParam || getCookie(COOKIES.CAMPAIGN_CODE) || undefined;
}

function getSixsenseCad() {
  if (!cookieEnabled(COOKIES.CONSENT.SIX_SENSE)) {
    return {};
  }
  const details = parseJSONSafe(
    localStorage.getItem(STORAGE.LOCAL.SIX_SENSE_COMPANY_DETAILS),
  );
  const company = details?.company;
  if (!company) {
    return {};
  }
  return {
    organization: company.name,
    country: company.country,
    city: company.city,
    employee_count: company.employee_count,
    annual_revenue: company.annual_revenue,
  };
}

function getCategoryCad() {
  const metadata = (name) => getMetadata(name) || undefined;
  const subKey = (prefix, value) =>
    value ? `${prefix}_${value.toLowerCase().split(' ').join('_')}` : null;

  const product = metadata('product_category');
  const software = metadata('software_product');
  const industry = metadata('industry');

  return {
    product_category: product,
    product_sub_category: product
      ? metadata(subKey('product_category', product))
      : undefined,
    software_product: software,
    software_sub_product: software
      ? metadata(subKey('software_product', software))
      : undefined,
    industry_category: industry,
    industry_sub_category: industry
      ? metadata(subKey('industry', industry))
      : undefined,
  };
}

function getDeviceCad() {
  const browserInfo = Bowser.getParser(navigator.userAgent).parsedResult;

  return {
    device: browserInfo.platform.type,
    browser: `${browserInfo.browser.name} ${browserInfo.browser.version}`,
    os: browserInfo.os.name,
  };
}

function getAdvisorCad() {
  return {
    agent_chat_start_url: window.agent_chat_start_url || window.location.href,
    ai_summary:
      typeof window.ai_summary !== 'undefined' ? window.ai_summary : '',
  };
}

function getResourceTabActive() {
  const shell = document.querySelector('.masthead.block udex-masthead-shell');
  if (!shell) {
    return false;
  }
  const items = shell.querySelectorAll('udex-masthead-item');
  for (const item of items) {
    const label =
      item.getAttribute('label') || item.getAttribute('accessible-name');
    if (label === 'Resources') {
      return item.selected === true || item.hasAttribute('selected');
    }
  }
  return false;
}

export function buildContactUsCad() {
  const cad = {
    client_id: getCookie(COOKIES.CLIENT) || undefined,
    adobe_id: getAdobeId() || getAltAdobeId(),
    url: window.location.href,
    countrySite: getCountrySite(),
    referrer: document.referrer || undefined,
    useragent: navigator.userAgent,
    // Save the ID for the post-chat survey.
    SurveyID: window.crypto?.randomUUID?.(),
    campaigncode: getCampaigncode(),
    ...getDeviceCad(),
    ...getAdvisorCad(),
    resource_tab_active: getResourceTabActive(),
    ...getSixsenseCad(),
    ...getCategoryCad(),
  };
  if (cad.SurveyID) {
    window.lastSurveyID = cad.SurveyID;
  }

  for (const key of Object.keys(cad)) {
    if (cad[key] === undefined) {
      delete cad[key];
    }
  }
  return cad;
}
